var _path, _rect, _rect2, _g, _rect3, _g2, _g3, _circle, _circle2, _path2, _g4, _g5, _g6, _g7, _circle3, _circle4, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 137,
    viewBox: "0 0 118 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 58.2652C58.8813 58.4116 59.1187 58.4116 59.2652 58.2652L61.6516 55.8787C61.7981 55.7322 61.7981 55.4948 61.6516 55.3484C61.5052 55.2019 61.2678 55.2019 61.1213 55.3484L59 57.4697L56.8787 55.3484C56.7322 55.2019 56.4948 55.2019 56.3483 55.3484C56.2019 55.4948 56.2019 55.7322 56.3483 55.8787L58.7348 58.2652ZM58.625 30L58.625 31.5L59.375 31.5L59.375 30L58.625 30ZM58.625 32.5L58.625 35.5L59.375 35.5L59.375 32.5L58.625 32.5ZM58.625 36.5L58.625 39.5L59.375 39.5L59.375 36.5L58.625 36.5ZM58.625 40.5L58.625 43.5L59.375 43.5L59.375 40.5L58.625 40.5ZM58.625 44.5L58.625 47.5L59.375 47.5L59.375 44.5L58.625 44.5ZM58.625 48.5L58.625 51.5L59.375 51.5L59.375 48.5L58.625 48.5ZM58.625 52.5L58.625 55.5L59.375 55.5L59.375 52.5L58.625 52.5ZM58.625 56.5L58.625 58L59.375 58L59.375 56.5L58.625 56.5Z",
    fill: "#42CFEF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_936_12235)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 18.6641L20.3333 17.6641M22.0034 15.1641V14.6641M23.3165 15.6843L23.6701 15.3307M23.3165 18.3307L23.6701 18.6843M20.6701 15.6843L20.3165 15.3307M23.8367 16.9974H24.3367M19.0437 20.9536L22.1228 17.8745C22.2548 17.7425 22.3208 17.6765 22.3456 17.6004C22.3673 17.5335 22.3673 17.4613 22.3456 17.3944C22.3208 17.3183 22.2548 17.2523 22.1228 17.1203L21.8771 16.8745C21.7451 16.7425 21.6791 16.6765 21.603 16.6518C21.536 16.63 21.4639 16.63 21.3969 16.6518C21.3208 16.6765 21.2548 16.7425 21.1228 16.8745L18.0437 19.9536C17.9117 20.0856 17.8457 20.1516 17.821 20.2277C17.7992 20.2947 17.7992 20.3668 17.821 20.4337C17.8457 20.5098 17.9117 20.5758 18.0437 20.7079L18.2895 20.9536C18.4215 21.0856 18.4875 21.1516 18.5636 21.1763C18.6306 21.1981 18.7027 21.1981 18.7696 21.1763C18.8457 21.1516 18.9117 21.0856 19.0437 20.9536Z",
    stroke: "#FFF4F0",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_936_12235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 59,
    width: 64,
    height: 18,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 63.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#12B76A",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4112 66.2709L36.7262 68.8621L36.0137 68.1009C35.8825 67.9771 35.6762 67.9696 35.5262 68.0746C35.38 68.1834 35.3387 68.3746 35.4287 68.5284L36.2725 69.9009C36.355 70.0284 36.4975 70.1071 36.6587 70.1071C36.8125 70.1071 36.9587 70.0284 37.0412 69.9009C37.1762 69.7246 39.7525 66.6534 39.7525 66.6534C40.09 66.3084 39.6812 66.0046 39.4112 66.2671V66.2709Z",
    fill: "#DDFFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4716 67.0739H50.5852C50.5511 66.8845 50.4877 66.7178 50.3949 66.5739C50.3021 66.4299 50.1884 66.3078 50.054 66.2074C49.9195 66.107 49.7689 66.0312 49.6023 65.9801C49.4375 65.929 49.2623 65.9034 49.0767 65.9034C48.7415 65.9034 48.4413 65.9877 48.1761 66.1562C47.9129 66.3248 47.7045 66.572 47.5511 66.8977C47.3996 67.2235 47.3239 67.6212 47.3239 68.0909C47.3239 68.5644 47.3996 68.964 47.5511 69.2898C47.7045 69.6155 47.9138 69.8617 48.179 70.0284C48.4441 70.1951 48.7424 70.2784 49.0739 70.2784C49.2576 70.2784 49.4318 70.2538 49.5966 70.2045C49.7633 70.1534 49.9138 70.0786 50.0483 69.9801C50.1828 69.8816 50.2964 69.7614 50.3892 69.6193C50.4839 69.4754 50.5492 69.3106 50.5852 69.125L51.4716 69.1278C51.4242 69.4138 51.3324 69.6771 51.196 69.9176C51.0616 70.1562 50.8883 70.3627 50.6761 70.5369C50.4659 70.7093 50.2254 70.8428 49.9545 70.9375C49.6837 71.0322 49.3883 71.0795 49.0682 71.0795C48.5644 71.0795 48.1155 70.9602 47.7216 70.7216C47.3277 70.4811 47.017 70.1373 46.7898 69.6903C46.5644 69.2434 46.4517 68.7102 46.4517 68.0909C46.4517 67.4697 46.5653 66.9366 46.7926 66.4915C47.0199 66.0445 47.3305 65.7017 47.7244 65.4631C48.1184 65.2225 48.5663 65.1023 49.0682 65.1023C49.3769 65.1023 49.6648 65.1468 49.9318 65.2358C50.2008 65.3229 50.4422 65.4517 50.6562 65.6222C50.8703 65.7907 51.0473 65.9972 51.1875 66.2415C51.3277 66.4839 51.4223 66.7614 51.4716 67.0739ZM53.3033 68.4091V71H52.4538V65.1818H53.2919V67.3466H53.3459C53.4482 67.1117 53.6044 66.9252 53.8146 66.7869C54.0249 66.6487 54.2995 66.5795 54.6385 66.5795C54.9377 66.5795 55.1991 66.6411 55.4226 66.7642C55.648 66.8873 55.8222 67.071 55.9453 67.3153C56.0703 67.5578 56.1328 67.8608 56.1328 68.2244V71H55.2834V68.3267C55.2834 68.0066 55.201 67.7585 55.0362 67.5824C54.8714 67.4044 54.6423 67.3153 54.3487 67.3153C54.148 67.3153 53.968 67.358 53.8089 67.4432C53.6518 67.5284 53.5277 67.6534 53.4368 67.8182C53.3478 67.9811 53.3033 68.178 53.3033 68.4091ZM58.5362 71.0966C58.2597 71.0966 58.0097 71.0455 57.7862 70.9432C57.5627 70.839 57.3857 70.6884 57.255 70.4915C57.1262 70.2945 57.0618 70.053 57.0618 69.767C57.0618 69.5208 57.1091 69.3182 57.2038 69.1591C57.2985 69 57.4264 68.8741 57.5874 68.7812C57.7483 68.6884 57.9283 68.6184 58.1271 68.571C58.326 68.5237 58.5286 68.4877 58.7351 68.4631C58.9964 68.4328 59.2086 68.4081 59.3714 68.3892C59.5343 68.3684 59.6527 68.3352 59.7266 68.2898C59.8004 68.2443 59.8374 68.1705 59.8374 68.0682V68.0483C59.8374 67.8002 59.7673 67.608 59.6271 67.4716C59.4889 67.3352 59.2824 67.267 59.0078 67.267C58.7218 67.267 58.4964 67.3305 58.3317 67.4574C58.1688 67.5824 58.0561 67.7216 57.9936 67.875L57.1953 67.6932C57.29 67.428 57.4283 67.214 57.6101 67.0511C57.7938 66.8864 58.005 66.767 58.2436 66.6932C58.4822 66.6174 58.7332 66.5795 58.9964 66.5795C59.1707 66.5795 59.3554 66.6004 59.5504 66.642C59.7474 66.6818 59.9311 66.7557 60.1016 66.8636C60.2739 66.9716 60.415 67.1259 60.5249 67.3267C60.6347 67.5256 60.6896 67.7841 60.6896 68.1023V71H59.8601V70.4034H59.826C59.7711 70.5133 59.6887 70.6212 59.5788 70.7273C59.469 70.8333 59.3279 70.9214 59.1555 70.9915C58.9832 71.0616 58.7768 71.0966 58.5362 71.0966ZM58.7209 70.4148C58.9557 70.4148 59.1565 70.3684 59.3232 70.2756C59.4917 70.1828 59.6196 70.0616 59.7067 69.9119C59.7957 69.7604 59.8402 69.5985 59.8402 69.4261V68.8636C59.8099 68.8939 59.7512 68.9223 59.6641 68.9489C59.5788 68.9735 59.4813 68.9953 59.3714 69.0142C59.2616 69.0312 59.1546 69.0473 59.0504 69.0625C58.9463 69.0758 58.8591 69.0871 58.7891 69.0966C58.6243 69.1174 58.4737 69.1525 58.3374 69.2017C58.2029 69.2509 58.0949 69.322 58.0135 69.4148C57.9339 69.5057 57.8942 69.6269 57.8942 69.7784C57.8942 69.9886 57.9718 70.1477 58.1271 70.2557C58.2824 70.3617 58.4804 70.4148 58.7209 70.4148ZM62.6705 68.4091V71H61.821V66.6364H62.6364V67.3466H62.6903C62.7907 67.1155 62.9479 66.9299 63.1619 66.7898C63.3778 66.6496 63.6496 66.5795 63.9773 66.5795C64.2746 66.5795 64.535 66.642 64.7585 66.767C64.982 66.8902 65.1553 67.0739 65.2784 67.3182C65.4015 67.5625 65.4631 67.8646 65.4631 68.2244V71H64.6136V68.3267C64.6136 68.0104 64.5313 67.7633 64.3665 67.5852C64.2017 67.4053 63.9754 67.3153 63.6875 67.3153C63.4905 67.3153 63.3153 67.358 63.1619 67.4432C63.0104 67.5284 62.8902 67.6534 62.8011 67.8182C62.714 67.9811 62.6705 68.178 62.6705 68.4091ZM67.4517 68.4091V71H66.6023V66.6364H67.4176V67.3466H67.4716C67.572 67.1155 67.7292 66.9299 67.9432 66.7898C68.1591 66.6496 68.4309 66.5795 68.7585 66.5795C69.0559 66.5795 69.3163 66.642 69.5398 66.767C69.7633 66.8902 69.9366 67.0739 70.0597 67.3182C70.1828 67.5625 70.2443 67.8646 70.2443 68.2244V71H69.3949V68.3267C69.3949 68.0104 69.3125 67.7633 69.1477 67.5852C68.983 67.4053 68.7566 67.3153 68.4688 67.3153C68.2718 67.3153 68.0966 67.358 67.9432 67.4432C67.7917 67.5284 67.6714 67.6534 67.5824 67.8182C67.4953 67.9811 67.4517 68.178 67.4517 68.4091ZM73.2642 71.0881C72.8343 71.0881 72.464 70.9962 72.1534 70.8125C71.8447 70.6269 71.6061 70.3665 71.4375 70.0312C71.2708 69.6941 71.1875 69.2992 71.1875 68.8466C71.1875 68.3996 71.2708 68.0057 71.4375 67.6648C71.6061 67.3239 71.8409 67.0578 72.142 66.8665C72.4451 66.6752 72.7992 66.5795 73.2045 66.5795C73.4508 66.5795 73.6894 66.6203 73.9205 66.7017C74.1515 66.7831 74.3589 66.911 74.5426 67.0852C74.7263 67.2595 74.8712 67.4858 74.9773 67.7642C75.0833 68.0407 75.1364 68.3769 75.1364 68.7727V69.0739H71.6676V68.4375H74.304C74.304 68.214 74.2585 68.0161 74.1676 67.8438C74.0767 67.6695 73.9489 67.5322 73.7841 67.4318C73.6212 67.3314 73.4299 67.2812 73.2102 67.2812C72.9716 67.2812 72.7633 67.34 72.5852 67.4574C72.4091 67.5729 72.2727 67.7244 72.1761 67.9119C72.0814 68.0975 72.0341 68.2992 72.0341 68.517V69.0142C72.0341 69.3059 72.0852 69.554 72.1875 69.7585C72.2917 69.9631 72.4366 70.1193 72.6222 70.2273C72.8078 70.3333 73.0246 70.3864 73.2727 70.3864C73.4337 70.3864 73.5805 70.3636 73.7131 70.3182C73.8456 70.2708 73.9602 70.2008 74.0568 70.108C74.1534 70.0152 74.2273 69.9006 74.2784 69.7642L75.0824 69.9091C75.018 70.1458 74.9025 70.3532 74.7358 70.5312C74.571 70.7074 74.3636 70.8447 74.1136 70.9432C73.8655 71.0398 73.5824 71.0881 73.2642 71.0881ZM76.9283 65.1818V71H76.0788V65.1818H76.9283ZM82.3842 65.1818V71H81.5036V66.0625H81.4695L80.0774 66.9716V66.1307L81.5291 65.1818H82.3842Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_936_12235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 41,
    r: 9,
    stroke: "#46A7BD",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 41,
    r: 9,
    stroke: "#42CFEF",
    strokeWidth: 0.6,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 41,
    r: 7,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 38.5H61V43.5H59.5V44.5H63.5V43.5H62V38.5H63.5V37.5H59.5V38.5ZM57.5 37.5H55.5C54.9485 37.5 54.5 37.9485 54.5 38.5V44.5H55.5V42H57.5V44.5H58.5V38.5C58.5 37.9485 58.0515 37.5 57.5 37.5ZM55.5 41V38.5H57.5V41H55.5Z",
    fill: "url(#paint0_linear_936_12235)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter3_ddd_936_12235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 112,
    width: 64,
    height: 18,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 116.75,
    width: 8.5,
    height: 8.5,
    rx: 4.25,
    fill: "#12B76A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 116.75,
    width: 8.5,
    height: 8.5,
    rx: 4.25,
    stroke: "#12B76A",
    strokeWidth: 0.5,
    strokeDasharray: "2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4112 119.271L36.7262 121.862L36.0137 121.101C35.8825 120.977 35.6762 120.97 35.5262 121.075C35.38 121.183 35.3387 121.375 35.4287 121.528L36.2725 122.901C36.355 123.028 36.4975 123.107 36.6587 123.107C36.8125 123.107 36.9587 123.028 37.0412 122.901C37.1762 122.725 39.7525 119.653 39.7525 119.653C40.09 119.308 39.6812 119.005 39.4112 119.267V119.271Z",
    fill: "#DDFFE9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4716 120.074H50.5852C50.5511 119.884 50.4877 119.718 50.3949 119.574C50.3021 119.43 50.1884 119.308 50.054 119.207C49.9195 119.107 49.7689 119.031 49.6023 118.98C49.4375 118.929 49.2623 118.903 49.0767 118.903C48.7415 118.903 48.4413 118.988 48.1761 119.156C47.9129 119.325 47.7045 119.572 47.5511 119.898C47.3996 120.223 47.3239 120.621 47.3239 121.091C47.3239 121.564 47.3996 121.964 47.5511 122.29C47.7045 122.616 47.9138 122.862 48.179 123.028C48.4441 123.195 48.7424 123.278 49.0739 123.278C49.2576 123.278 49.4318 123.254 49.5966 123.205C49.7633 123.153 49.9138 123.079 50.0483 122.98C50.1828 122.882 50.2964 122.761 50.3892 122.619C50.4839 122.475 50.5492 122.311 50.5852 122.125L51.4716 122.128C51.4242 122.414 51.3324 122.677 51.196 122.918C51.0616 123.156 50.8883 123.363 50.6761 123.537C50.4659 123.709 50.2254 123.843 49.9545 123.938C49.6837 124.032 49.3883 124.08 49.0682 124.08C48.5644 124.08 48.1155 123.96 47.7216 123.722C47.3277 123.481 47.017 123.137 46.7898 122.69C46.5644 122.243 46.4517 121.71 46.4517 121.091C46.4517 120.47 46.5653 119.937 46.7926 119.491C47.0199 119.045 47.3305 118.702 47.7244 118.463C48.1184 118.223 48.5663 118.102 49.0682 118.102C49.3769 118.102 49.6648 118.147 49.9318 118.236C50.2008 118.323 50.4422 118.452 50.6562 118.622C50.8703 118.791 51.0473 118.997 51.1875 119.241C51.3277 119.484 51.4223 119.761 51.4716 120.074ZM53.3033 121.409V124H52.4538V118.182H53.2919V120.347H53.3459C53.4482 120.112 53.6044 119.925 53.8146 119.787C54.0249 119.649 54.2995 119.58 54.6385 119.58C54.9377 119.58 55.1991 119.641 55.4226 119.764C55.648 119.887 55.8222 120.071 55.9453 120.315C56.0703 120.558 56.1328 120.861 56.1328 121.224V124H55.2834V121.327C55.2834 121.007 55.201 120.759 55.0362 120.582C54.8714 120.404 54.6423 120.315 54.3487 120.315C54.148 120.315 53.968 120.358 53.8089 120.443C53.6518 120.528 53.5277 120.653 53.4368 120.818C53.3478 120.981 53.3033 121.178 53.3033 121.409ZM58.5362 124.097C58.2597 124.097 58.0097 124.045 57.7862 123.943C57.5627 123.839 57.3857 123.688 57.255 123.491C57.1262 123.295 57.0618 123.053 57.0618 122.767C57.0618 122.521 57.1091 122.318 57.2038 122.159C57.2985 122 57.4264 121.874 57.5874 121.781C57.7483 121.688 57.9283 121.618 58.1271 121.571C58.326 121.524 58.5286 121.488 58.7351 121.463C58.9964 121.433 59.2086 121.408 59.3714 121.389C59.5343 121.368 59.6527 121.335 59.7266 121.29C59.8004 121.244 59.8374 121.17 59.8374 121.068V121.048C59.8374 120.8 59.7673 120.608 59.6271 120.472C59.4889 120.335 59.2824 120.267 59.0078 120.267C58.7218 120.267 58.4964 120.33 58.3317 120.457C58.1688 120.582 58.0561 120.722 57.9936 120.875L57.1953 120.693C57.29 120.428 57.4283 120.214 57.6101 120.051C57.7938 119.886 58.005 119.767 58.2436 119.693C58.4822 119.617 58.7332 119.58 58.9964 119.58C59.1707 119.58 59.3554 119.6 59.5504 119.642C59.7474 119.682 59.9311 119.756 60.1016 119.864C60.2739 119.972 60.415 120.126 60.5249 120.327C60.6347 120.526 60.6896 120.784 60.6896 121.102V124H59.8601V123.403H59.826C59.7711 123.513 59.6887 123.621 59.5788 123.727C59.469 123.833 59.3279 123.921 59.1555 123.991C58.9832 124.062 58.7768 124.097 58.5362 124.097ZM58.7209 123.415C58.9557 123.415 59.1565 123.368 59.3232 123.276C59.4917 123.183 59.6196 123.062 59.7067 122.912C59.7957 122.76 59.8402 122.598 59.8402 122.426V121.864C59.8099 121.894 59.7512 121.922 59.6641 121.949C59.5788 121.973 59.4813 121.995 59.3714 122.014C59.2616 122.031 59.1546 122.047 59.0504 122.062C58.9463 122.076 58.8591 122.087 58.7891 122.097C58.6243 122.117 58.4737 122.152 58.3374 122.202C58.2029 122.251 58.0949 122.322 58.0135 122.415C57.9339 122.506 57.8942 122.627 57.8942 122.778C57.8942 122.989 57.9718 123.148 58.1271 123.256C58.2824 123.362 58.4804 123.415 58.7209 123.415ZM62.6705 121.409V124H61.821V119.636H62.6364V120.347H62.6903C62.7907 120.116 62.9479 119.93 63.1619 119.79C63.3778 119.65 63.6496 119.58 63.9773 119.58C64.2746 119.58 64.535 119.642 64.7585 119.767C64.982 119.89 65.1553 120.074 65.2784 120.318C65.4015 120.562 65.4631 120.865 65.4631 121.224V124H64.6136V121.327C64.6136 121.01 64.5313 120.763 64.3665 120.585C64.2017 120.405 63.9754 120.315 63.6875 120.315C63.4905 120.315 63.3153 120.358 63.1619 120.443C63.0104 120.528 62.8902 120.653 62.8011 120.818C62.714 120.981 62.6705 121.178 62.6705 121.409ZM67.4517 121.409V124H66.6023V119.636H67.4176V120.347H67.4716C67.572 120.116 67.7292 119.93 67.9432 119.79C68.1591 119.65 68.4309 119.58 68.7585 119.58C69.0559 119.58 69.3163 119.642 69.5398 119.767C69.7633 119.89 69.9366 120.074 70.0597 120.318C70.1828 120.562 70.2443 120.865 70.2443 121.224V124H69.3949V121.327C69.3949 121.01 69.3125 120.763 69.1477 120.585C68.983 120.405 68.7566 120.315 68.4688 120.315C68.2718 120.315 68.0966 120.358 67.9432 120.443C67.7917 120.528 67.6714 120.653 67.5824 120.818C67.4953 120.981 67.4517 121.178 67.4517 121.409ZM73.2642 124.088C72.8343 124.088 72.464 123.996 72.1534 123.812C71.8447 123.627 71.6061 123.366 71.4375 123.031C71.2708 122.694 71.1875 122.299 71.1875 121.847C71.1875 121.4 71.2708 121.006 71.4375 120.665C71.6061 120.324 71.8409 120.058 72.142 119.866C72.4451 119.675 72.7992 119.58 73.2045 119.58C73.4508 119.58 73.6894 119.62 73.9205 119.702C74.1515 119.783 74.3589 119.911 74.5426 120.085C74.7263 120.259 74.8712 120.486 74.9773 120.764C75.0833 121.041 75.1364 121.377 75.1364 121.773V122.074H71.6676V121.438H74.304C74.304 121.214 74.2585 121.016 74.1676 120.844C74.0767 120.67 73.9489 120.532 73.7841 120.432C73.6212 120.331 73.4299 120.281 73.2102 120.281C72.9716 120.281 72.7633 120.34 72.5852 120.457C72.4091 120.573 72.2727 120.724 72.1761 120.912C72.0814 121.098 72.0341 121.299 72.0341 121.517V122.014C72.0341 122.306 72.0852 122.554 72.1875 122.759C72.2917 122.963 72.4366 123.119 72.6222 123.227C72.8078 123.333 73.0246 123.386 73.2727 123.386C73.4337 123.386 73.5805 123.364 73.7131 123.318C73.8456 123.271 73.9602 123.201 74.0568 123.108C74.1534 123.015 74.2273 122.901 74.2784 122.764L75.0824 122.909C75.018 123.146 74.9025 123.353 74.7358 123.531C74.571 123.707 74.3636 123.845 74.1136 123.943C73.8655 124.04 73.5824 124.088 73.2642 124.088ZM76.9283 118.182V124H76.0788V118.182H76.9283ZM80.1768 124V123.364L82.1456 121.324C82.3558 121.102 82.5291 120.908 82.6655 120.741C82.8037 120.573 82.907 120.413 82.9751 120.261C83.0433 120.11 83.0774 119.949 83.0774 119.778C83.0774 119.585 83.032 119.419 82.9411 119.278C82.8501 119.136 82.7261 119.027 82.5689 118.952C82.4117 118.874 82.2346 118.835 82.0376 118.835C81.8293 118.835 81.6475 118.878 81.4922 118.963C81.3369 119.048 81.2176 119.169 81.1342 119.324C81.0509 119.479 81.0092 119.661 81.0092 119.869H80.1712C80.1712 119.515 80.2526 119.205 80.4155 118.94C80.5784 118.675 80.8018 118.47 81.0859 118.324C81.37 118.176 81.6929 118.102 82.0547 118.102C82.4202 118.102 82.7422 118.175 83.0206 118.321C83.3009 118.465 83.5196 118.662 83.6768 118.912C83.834 119.16 83.9126 119.44 83.9126 119.753C83.9126 119.969 83.8719 120.18 83.7905 120.386C83.7109 120.593 83.5717 120.823 83.3729 121.077C83.174 121.329 82.8975 121.634 82.5433 121.994L81.3871 123.205V123.247H84.0064V124H80.1768Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 87.2652C58.8813 87.4116 59.1187 87.4116 59.2652 87.2652L61.6517 84.8787C61.7981 84.7322 61.7981 84.4948 61.6517 84.3483C61.5052 84.2019 61.2678 84.2019 61.1213 84.3483L59 86.4697L56.8787 84.3483C56.7322 84.2019 56.4948 84.2019 56.3483 84.3483C56.2019 84.4948 56.2019 84.7322 56.3483 84.8787L58.7348 87.2652ZM58.625 77L58.625 78.25L59.375 78.25L59.375 77L58.625 77ZM58.625 79.0833L58.625 81.5833L59.375 81.5833L59.375 79.0833L58.625 79.0833ZM58.625 82.4167L58.625 84.9167L59.375 84.9167L59.375 82.4167L58.625 82.4167ZM58.625 85.75L58.625 87L59.375 87L59.375 85.75L58.625 85.75Z",
    fill: "#42CFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_936_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 77.4062L59 86.794",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 112.265C58.8813 112.412 59.1187 112.412 59.2652 112.265L61.6517 109.879C61.7981 109.732 61.7981 109.495 61.6517 109.348C61.5052 109.202 61.2678 109.202 61.1213 109.348L59 111.47L56.8787 109.348C56.7322 109.202 56.4948 109.202 56.3483 109.348C56.2019 109.495 56.2019 109.732 56.3483 109.879L58.7348 112.265ZM58.625 102L58.625 103.25L59.375 103.25L59.375 102L58.625 102ZM58.625 104.083L58.625 106.583L59.375 106.583L59.375 104.083L58.625 104.083ZM58.625 107.417L58.625 109.917L59.375 109.917L59.375 107.417L58.625 107.417ZM58.625 110.75L58.625 112L59.375 112L59.375 110.75L58.625 110.75Z",
    fill: "#42CFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_936_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 102.406L59 111.794",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_936_12235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 96,
    r: 9,
    stroke: "#46A7BD",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 96,
    r: 9,
    stroke: "#42CFEF",
    strokeWidth: 0.6,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 96,
    r: 7,
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4583 95.7917L62.6252 96.625L61.7916 95.7917M62.7271 96.4167C62.7422 96.2799 62.75 96.1408 62.75 96C62.75 93.9289 61.0711 92.25 59 92.25C56.9289 92.25 55.25 93.9289 55.25 96C55.25 98.0711 56.9289 99.75 59 99.75C60.178 99.75 61.2292 99.2068 61.9167 98.3572M59 93.9167V96L60.25 96.8333",
    stroke: "#394353",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_936_12235",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_936_12235",
    result: "effect2_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_936_12235",
    result: "effect3_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_936_12235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_936_12235",
    x: 18,
    y: 53,
    width: 82,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_936_12235",
    result: "effect2_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_936_12235",
    result: "effect3_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_936_12235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_936_12235",
    x: 46.625,
    y: 28.625,
    width: 24.75,
    height: 24.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_936_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddd_936_12235",
    x: 18,
    y: 106,
    width: 82,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_936_12235",
    result: "effect2_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_936_12235",
    result: "effect3_dropShadow_936_12235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_936_12235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_936_12235",
    x: 45.625,
    y: 64.4062,
    width: 26.75,
    height: 35.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_936_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_936_12235",
    x: 45.625,
    y: 89.4062,
    width: 26.75,
    height: 35.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_936_12235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_936_12235",
    x: 46.625,
    y: 83.625,
    width: 24.75,
    height: 24.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_936_12235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_936_12235",
    x1: 59,
    y1: 37.5,
    x2: 59,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0400FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_12235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_12235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(54 91)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartNode);
export default __webpack_public_path__ + "static/media/smartNode.0c44647fb80a38c7d4d532ec90745d7d.svg";
export { ForwardRef as ReactComponent };